/**
 * Client-side PWA mode: ?view=pwa OR progressify-me localStorage isInApp === true
 */
(function () {
  const STORAGE_KEY = 'progressify-me';

  function isInAppFromStorage() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      const data = JSON.parse(raw);
      return !!(data && data.isInApp === true);
    } catch (e) {
      return false;
    }
  }

  function isPwaFromUrl() {
    return new URLSearchParams(window.location.search).get('view') === 'pwa';
  }

  window.PwaMode = {
    isInAppFromStorage,
    isPwaFromUrl,
    isPwaMode() {
      return isPwaFromUrl() || isInAppFromStorage();
    },
  };

  // App-exclusive products render server-side with `hidden` + data-pwa-restrict
  // when the URL lacks ?view=pwa, since Liquid can't read localStorage. Reveal
  // them here from isInApp directly, so app users see them even before any
  // ?view=pwa redirect has happened (e.g. isInApp set after this page loaded).
  function revealPwaRestricted(root) {
    if (!isInAppFromStorage() && !isPwaFromUrl()) return;
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-pwa-restrict="only for pwa app"][hidden]').forEach((el) => {
      el.removeAttribute('hidden');
    });
  }

  revealPwaRestricted();

  // Exposed so the app's injectJavaScript call can force a re-check right
  // after it sets isInApp. A same-document localStorage write never fires a
  // 'storage' event (that only fires in OTHER tabs/documents), so without
  // this, isInApp set after this script already ran is never picked up.
  window.PwaMode.refresh = revealPwaRestricted;

  if (window.MutationObserver) {
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) revealPwaRestricted(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  // Cross-tab/window writes do fire 'storage' here, so cover that case too.
  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) revealPwaRestricted();
  });

  // Returning to the WebView (e.g. after the app backgrounds/foregrounds it)
  // is a common point for the app to have set isInApp in the meantime.
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) revealPwaRestricted();
  });

  // Safety net: if the app sets isInApp via injectJavaScript shortly after
  // load without calling PwaMode.refresh(), catch it within a few seconds
  // instead of leaving products hidden for the rest of the pageview.
  var pwaPollCount = 0;
  var pwaPollId = setInterval(function () {
    revealPwaRestricted();
    pwaPollCount += 1;
    if (pwaPollCount >= 10) clearInterval(pwaPollId);
  }, 500);
})();
